import { inject, Injectable } from '@angular/core';
import { ApiResponse, Article, ArticleClientMapping } from '@interfaces';
import { Observable } from 'rxjs';
import { ApiEndpointType, ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private readonly _apiPath = 'clients';
  private readonly _api = inject(ApiService);

  getClientByArticleNumber(
    articleNumber: string,
  ): Observable<ApiResponse<ArticleClientMapping[]>> {
    return this._api.get<ArticleClientMapping[]>(
      `${this._apiPath}/article/${articleNumber}`,
    );
  }

  getArticlesByClientId(clientId: string): Observable<ApiResponse<Article[]>> {
    return this._api.get<Article[]>(`${this._apiPath}/client/${clientId}`);
  }

  getClientInfoWithFilters(
    articleId?: string,
    clientId?: string,
    companyCode?: string,
  ): Observable<ApiResponse<ArticleClientMapping[]>> {
    const params = new URLSearchParams();
    if (articleId) {
      params.append('articleId', articleId);
    }
    if (clientId) {
      params.append('clientId', clientId);
    }
    if (companyCode) {
      params.append('companyCode', companyCode);
    }

    const queryString = params.toString();
    const url = queryString ? `${this._apiPath}?${queryString}` : this._apiPath;

    return this._api.get<ArticleClientMapping[]>(url);
  }

  removeArticleClientMapping(
    articleId: string,
    clientId: string,
    companyCode: string,
  ): Observable<ApiResponse<string>> {
    return this._api.delete(
      `${this._apiPath}`,
      {
        body: {
          articleId,
          clientId,
          companyCode,
        },
      },
      ApiEndpointType.Server,
    );
  }

  addArticleClientMapping(
    articleId: string,
    clientId: string,
    companyCode: string,
  ): Observable<ApiResponse<ArticleClientMapping>> {
    return this._api.put<ArticleClientMapping, ArticleClientMapping>(
      `${this._apiPath}`,
      {
        articleId,
        clientId,
        companyCode,
      },
    );
  }
}
